<script lang="ts">
    import type { Schedule } from '../../modules/schedulerApi/schedules/schedule'
    import Zinput from '../_common/z/zinput.svelte'
    import ZContainer from '../_common/z/z-container.svelte'

    export let schedule: Schedule

    // o Zinput type="time" trabalha com Date (entra Date, sai Date) — nunca com string 'HH:mm'
    let startTime: Date = minuteToDate(schedule.startMinute)
    let endTime: Date = minuteToDate(schedule.endMinute)

    function minuteToDate(minute: number): Date {
        if (!Number.isFinite(minute)) return null
        const date = new Date()
        date.setHours(0, minute, 0, 0)
        return date
    }

    function dateToMinute(date): number {
        const value = date instanceof Date ? date : new Date(date)
        if (isNaN(value.getTime())) return null
        return value.getHours() * 60 + value.getMinutes()
    }

    $: schedule.startMinute = startTime ? dateToMinute(startTime) : null
    $: schedule.endMinute = endTime ? dateToMinute(endTime) : null
</script>

<ZContainer class="mt-2" gapRow="8px" gapCol="8px">
    <Zinput size={4} sizeM={12} label="Nome" type="text" bind:value={schedule.label} />
    <Zinput size={2} sizeM={6} label="Início" type="time" bind:value={startTime} />
    <Zinput size={2} sizeM={6} label="Fim" type="time" bind:value={endTime} />
    <!-- o sufixo "minutos" era um addon do input-group; no Zinput ele cabe no próprio rótulo -->
    <Zinput size={3} sizeM={12} label="Intervalo (minutos)" type="number" bind:value={schedule.range} />
</ZContainer>
